enum WorkspaceProjectAiChatFileType {
  generic = 'generic',
  project = 'project',
}

export default WorkspaceProjectAiChatFileType
